import React, { useEffect, useMemo } from "react";
import { useQueryClient } from "react-query";
import useAuthenticationContext from "@/services/context/authentication/use-authentication-context";
import createProjectProcessRunner from "./project-process-runner";
import { ProjectProcessRunnerContext } from "./project-process-context-props";

const ProjectProcessRunnerProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const queryClient = useQueryClient();
    const { authenticationResponse } = useAuthenticationContext();
    const runner = useMemo(() => createProjectProcessRunner(queryClient), [queryClient]);
    const userId = authenticationResponse?.user.id;

    useEffect(() => {
        runner.setUser(userId);
        return () => { runner.setUser(undefined); };
    }, [runner, userId]);

    return <ProjectProcessRunnerContext.Provider value={runner}>{children}</ProjectProcessRunnerContext.Provider>;
};

export default ProjectProcessRunnerProvider;
